<template>
    <div class="all">
        <div class="screen">
            <div class="item clearfix">
                <span class="zu clearfix">
                    <span class="d-flex">
				        <span class="name">媒体类别</span>
                        <platTypeCascader title="媒体类别" :industryTypeList="mediaLevelList" :morenzhi="morenzhi" @putData="getPlanvalue"></platTypeCascader>
				    </span>
                </span>
                <span class="zu clearfix">
                    <span class="name">发布地区</span>
                    <city @cityCallback="citySelect" levels="1"></city>
                </span>
                <span class="fr">
                    <button class="btn btn-blue" @click="openSetModal">设置</button>
                </span>
            </div>
            <div class="item mt10 clearfix">
                <span class="name">情感属性</span>
                <div class="screen-list">
                    <label class="checkbox-box" v-for="(item,index) in emotionList" :key="index">
                        <label class="checkbox-warp fl" :class="emotion.indexOf(item) != -1 ? 'curr' : ''">
                            <input class="checkbox" v-model="emotion" name="" type="checkbox" :value="item">
                            <i class="icons checkbox-icon"></i>
                        </label>
                        {{item}}
                    </label>
                </div>
            </div>
            <div class="item mt20 clearfix">
                <span class="name">媒体类型</span>
                <div class="screen-list">
                    <label class="checkbox-box" v-for="(item,index) in MediaPlatformList" :key="index">
                        <label class="checkbox-warp fl" :class="platformType.indexOf(index) != -1 ? 'curr' : ''">
                            <input class="checkbox" v-model="platformType" name="" type="checkbox" :value="index">
                            <i class="icons checkbox-icon"></i>
                        </label>
                        {{item.name}} <span class="color-8a8a99">({{item.num}})</span>
                    </label>
                </div>
            </div>
            <div class="item clearfix">
                <span class="zu clearfix">
                    <span class="name">重复信息</span>
                    <span class="drop-down">
                        <button class="btn btn-lightblue"><span class="texts">{{repeatList[collapse]}}</span><i class="icons"></i></button>
                        <ul class="option">
                            <li v-for="(item,index) in repeatList" @click="selectRepeat(index)" :key="index">{{item}}</li>
                        </ul>
                    </span>
                </span>
            </div>
        </div>
        <div class="warp mt20">
            <div class="warp-header">
                <div class="firle clearfix">
                    <div class="fl">
                        <label class="checkbox-box tion">
                            <label class="checkbox-warp fl" :class="uuids.length === pageUuid.length &&  uuids.length > 0 ? 'curr' : ''">
                                <input class="checkbox" name="selectAll" :checked="uuids.length === pageUuid.length && uuids.length > 0 ? true : false"  @click="checkAll($event)" type="checkbox" value="0">
                                <i class="icons checkbox-icon"></i>
                            </label>
                            全选
                        </label>
                        <span class="checkbox-box cp tion" @click="sendEarlyWarning(0);">预警</span>
                        <!-- <span class="checkbox-box tion">删除</span> -->
                        <span class="checkbox-box cp tion" @click="downLoad(1);" title="下载当前所选数据">批量下载</span>
                        <span class="checkbox-box cp tion" @click="downLoad(2);" title="下载当前方案的所有数据">全部下载</span>
                    </div>
                    <div class="fr">
                        <span class="tion clearfix">
                            <div class="search-warp clearfix">
                                <span class="drop-down fl">
                                    <button class="btn search-dropdown"><span class="text">搜媒体</span></button>
                                </span>
                                <button class="search-btn fr" @click="getNewsList(0);"><i class="icons search-icon"></i></button> 
                                <div class="hidden"><input type="text" v-model.trim="keywords" @keyup.enter="KeyUpEsc" :placeholder="searchPlaceholder[searchSelectVal - 1]" class="input-text"></div>
                            </div>
                        </span>
                    </div>
                </div>
            </div>
            <!-- 定时查看数据 -->
            <div class="blue-block ac" v-if="noUpdateNum > 0"><a class="color-blue" href="javascript:void(0);" @click="updateCurrentData();">{{noUpdateNum}}条新消息，点击查看</a></div>
            <div class="warp-body clearfix">
                <div class="no-data" v-if="nodata"><span class="text">没有数据哦...</span></div>
                <ul class="article-list mtfu24">
                    <li v-for="(item,index) in newsList" :key="index">
                        <div class="article-left fl">
                            <label class="checkbox-warp" :class="uuids.indexOf(item.newsId) != -1 ? 'curr' : ''">
                                <input class="checkbox" v-model="uuids" name="chooseInfo" type="checkbox" :value="item.newsId">
                                <i class="icons checkbox-icon"></i>
                            </label>     
                        </div> 
                        <div class="article-right fr">
                            <div class="article-btn">
                                <span class="collect" @click="collectFn(index);" :class="item.collectStatus === 0 ? '' : 'curr'"><i class="icons collect-icon"></i></span>
                                <!-- <span class="sign sign-blue">改</span> -->
                                <span class="sign sign-orange cp" :class="item.warningStatus === 0 ? '' : 'gray'" @click="sendEarlyWarning(item.warningStatus,item.newsId);">警</span>
                                <!-- <span class="sign sign-red cp" @click="errorCorrection(item.newsId);">纠</span> -->
                                <!-- <span class="sign sign-red">删</span> -->
                            </div>  
                        </div> 
                        <div class="article-mid">
                            <router-link class="color-3d3d4c" target="_blank" :to="{path:'/detail',query: {data:item.newsId+','+item.newsSimHash+','+startDate+','+endDate}}">
                                <h2 class="article-title ovhidden" :title="item.newsTitle"><span class="tag" :class="attributeType[item.newsEmotion]">{{item.newsEmotion}}</span><span v-html="item.newsTitle"></span></h2>
                                <p class="ovhidden2 color-8a8a99" :title="item.newsDigest" v-html="item.newsDigest"></p>
                            </router-link>
                            <p class="ziduan color-8a8a99 mt10">
                                <span>时间：{{item.newsPosttime}}</span>
                                <span>相似文章：<i class="color-blue" :class="item.simNum === '' ? 'load-sm' : ''">{{item.simNum}}</i></span>
                                <span>发布平台：<i class="icons sm-icon" :class="icons[item.platform]"></i>{{item.platformName}}</span>
                                <span>发布人：{{item.mediaName}}</span>
                                <span v-if="item.mediaProvince != ''">发布地区：{{item.mediaProvince}}</span>
                                <span  v-if="item.keywords != ''">分析词：<i :class="item.keywords == '' ? 'load-sm' : ''"></i>{{item.keywords}}</span>
                            </p>
                        </div> 
                    </li>
                </ul>
                <!-- 分页 -->
                <page class="mt20" v-if="totalCount != ''" :currentPage.sync="page" :limit.sync="limit" :totalCount="totalCount" @turn="getTableData"></page>
            </div>
        </div>
        <!-- 下载选项 -->
        <Dialog ref="downloadOption" title="下载字段自定义选择" btnText="下载" :callback="enterOption" type="normal" width="600">
            <div slot="mdBox">
                <div class="checkbox-group nolike clearfix">
                    <label class="checkbox-box">
                        <label class="checkbox-warp fl" :class="selectOptionValue.length === $parent.selectOption.length ? 'curr' : ''"><input name="" :checked="selectOptionValue.length === $parent.selectOption.length ? true : false" type="checkbox" @click="optionCheckAll($event);" value="" class="checkbox"> <i class="icons checkbox-icon"></i></label>
                        <div class="hidden ac">全选<span class="color-red">（为保证您的下载速度，请尽可能筛选必要的下载字段）</span></div>
                    </label>
                </div>
                <div class="checkbox-group nolike clearfix">
                    <label class="checkbox-box" v-for="(item,index) in $parent.selectOption" :key="index">
                        <label class="checkbox-warp fl" :class="selectOptionValue.indexOf(item.type) != -1 ? 'curr' : ''"><input name="" v-model="selectOptionValue" type="checkbox" :value="item.type" class="checkbox"> <i class="icons checkbox-icon"></i></label>
                        <div class="hidden ac">{{item.name}}</div>
                    </label>
                </div>
            </div>
        </Dialog>
        <!-- 情感属性纠错 -->
        <Dialog ref="allInformationSet" title="方案信息汇总设置（设置成功后，信息更新后即可查看结果）" :callback="setSave" btnText="确定" type="normal" width="500">
            <div slot="mdBox">
                <div class="form-warp name-width0">
                    <div class="item clearfix">
                        <span class="name fl clearfix">
                            <span class="fl">定向信源:</span>
                            <div class="grid-info fl al">
                                <i class="icons icons-question-circle"></i>
                                <p class="grid-tip">定向信源来自舆情分析指定信源设置的站点信息。选择重点关注，则汇总多个方案的指定信源设置的站点信息。</p>
                            </div>
                        </span>
                        <div class="input-father checkbox-group">
                            <label class="checkbox-box">
                                <label class="checkbox-warp fl" :class="{curr:source === '0'}"><input v-model="source" name="xinyuan" type="radio" value="0" class="radio"> <i class="icons radio-icon"></i></label>
                                <div class="hidden ac">全部</div>
                            </label>
                            <label class="checkbox-box">
                                <label class="checkbox-warp fl" :class="{curr:source === '1'}"><input v-model="source" name="xinyuan" type="radio" value="1" class="radio"> <i class="icons radio-icon"></i></label>
                                <div class="hidden ac">重点关注</div>
                            </label>
                        </div>
                    </div>
                </div>
            </div>
        </Dialog>
        <Dialog ref="sendDialog" title="发送预警" :callback="earlyWarning" width="640">
            <div slot="mdBox" >
                <div class="modal-inside">
                    <div class="form-warp name-width0">
                        <div class="item mt10 clearfix report-drop">
                            <span class="name fl">微信:</span>
                            <div class="input-father report-btn w325" @click="isHasUser(1)">
                                <input class="input-text" type="text" placeholder="请点击输入框添加接收人的微信账号" v-model.trim="reportForm.wx" readonly/>
                            </div>
                            <div class="clearfix report-down" v-if="wxList.length>0">
                                <div class="input-father checkbox-group">
                                    <label class="checkbox-box mt10" v-for="(item,index) in wxList" :key="index">
                                        <label class="checkbox-warp fl" :class="{'curr':checkedWx.toString().indexOf(item.username+'-'+item.id) != -1 }">
                                            <input name="" type="checkbox" class="checkbox" :value="item.username+'-'+item.id" v-model="checkedWx"/> 
                                            <i class="icons checkbox-icon"></i>
                                        </label>
                                        <div class="ovhidden ac">{{item.username}}</div>
                                    </label>
                                </div>    
                            </div>
                        </div>
                        <div class="item mt15 clearfix report-drop">
                            <span class="name fl">邮箱:</span>
                            <div class="input-father report-btn w325" @click="isHasUser(2)">
                                <input class="input-text" type="text" placeholder="填写接收人邮箱地址，多个地址请用,隔开" v-model.trim="reportForm.email" readonly/>
                            </div>
                            <div class="clearfix report-down" v-if="emailList.length>0">
                                <div class="input-father checkbox-group">
                                    <label class="checkbox-box mt10" v-for="(item,index) in emailList" :key="index">
                                        <label class="checkbox-warp fl" :class="{'curr':checkedEmail.toString().indexOf(item.username+'-'+item.id) != -1 }">
                                            <input name="" type="checkbox" class="checkbox" :value="item.username+'-'+item.id" v-model="checkedEmail"/> 
                                            <i class="icons checkbox-icon"></i>
                                        </label>
                                        <div class="ovhidden ac">{{item.username}}</div>
                                    </label>
                                </div>    
                            </div>
                        </div>
                        <div class="item mt15 clearfix report-drop">
                            <span class="name fl">手机:</span>
                            <div class="input-father report-btn w325" @click="isHasUser(3)">
                                <input class="input-text" type="text" placeholder="填写接收人手机号码，多个号码请用,隔开，使用短信接收可能会产生额外费用" v-model.trim="reportForm.tel" readonly/>
                            </div>
                            <div class="clearfix report-down" v-if="telList.length>0">
                                <div class="input-father checkbox-group">
                                    <label class="checkbox-box mt10" v-for="(item,index) in telList" :key="index">
                                        <label class="checkbox-warp fl" :class="{'curr':checkedTel.toString().indexOf(item.username+'-'+item.id) != -1 }">
                                            <input name="" type="checkbox" class="checkbox" :value="item.username+'-'+item.id" v-model="checkedTel"/> 
                                            <i class="icons checkbox-icon"></i>
                                        </label>
                                        <div class="hidden ac">{{item.username}}</div>
                                    </label>
                                </div>    
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Dialog>
	</div>
</template>
<script>
import Dialog from '../../components/dialog.vue'
import VueDatepickerLocal from 'vue-datepicker-local'
import city from '../../components/city.vue';
import page from '../../components/page.vue';
import platTypeCascader from '../../components/platTypeCascader.vue';
import {mapState} from 'vuex';
export default {
    components:{VueDatepickerLocal,city,page,Dialog,platTypeCascader},
    computed:{
        ...mapState({
            sid: state => state.allInformationSet.sid,
            yujinType: state => state.show.yujinType,
            mediaLevelList: state => state.show.companyinfo.mediaLevelList
        })
    },
    data() {
        const min = ''
        const max = ''
        return {
            attributeType:{
                '正面':'tag-blue',
                '中性':'tag-orange',
                '负面':'tag-red',
            },//属性对应的class样式
            icons:{
                'wx':'wx-icon',
                'web':'web-icon1',
                'weibo':'wb-icon1',
                'app':'app-icon1',
                'bbs':'bbs-icon1',
                'journal':'bk-icon1',
                'media_toutiao':'tt-icon1',
                'media_qq':'qq-icon1',
                'media_baijia':'bj-icon1',
                'media_sohu':'sh-icon1',
                'media_wangyi':'wy-icon1',
                'media_people':'people-icon1'
            },
            timeRange: [min, max],//时间
            selectOptionValue:[],//已选择下载
            mediaList:['全部','政府','媒体','个人','其他'],//媒体字段
            emotionList:['全部','正面','中性','负面'],//情感字段
            emotion:['全部'],//情感属性
            pipei:['全文匹配','标题匹配'],//匹配字段
            repeatList:['不去重','去重'],//相似文章
            collapse:0,//去重type 0是不去重 1是去重
            paixu:[
                {'name':'时间降序','enName':'desc'},
                {'name':'时间升序','enName':'asc'}
            ],//排序字段 
            searchPlaceholder:['请输入媒体发布人查询','请输入信息内容查询','请输入信息标题查询'],//搜索提示语
            MediaPlatformList:[],//媒体类型数组
            page:1,//页码
            morenzhi:{},
            limit:20,//每页显示条数
            totalCount:'',//总页数
            pageUuid:[],//单分页所有的uuid
            uuids:[],//选择的newsid数组
            newsId:[],//预警提交的id参数
            earlyWarningType:'',
            planId:'',//方案ID
            mediaLevel:'',//媒体分类
            platformType:['total'],//媒体类型
            startDate:'',//开始时间
            endDate:'',//结束时间
            // timeType:0,//时间乐类型
            searchSelectVal:3,//搜素是的分类
            pubArea:'',
            match:'1',//匹配方式 1是全文匹配 2是标题匹配
            sort:'desc',//排序类型 desc是降序 asc是升序
            keywords:'',//媒体关键词
            newsList:[],//新闻列表
            watch:true,//是否监听
            downLoadType:'',//下载类型
            nodata:false,//暂无数据
            noUpdateNum:0,//未更新条数
            timer:'',//请求定时器
            errorAttribute:'',//纠错属性的值
            source:'',
            reportForm:{},//预警联系人
            wxList:[],
            emailList:[],
            telList:[],
            checkedWx:[],
            curWx:'', 
            curEmail:'', 
            checkedEmail:[],
            curTel:'', 
            checkedTel:[]
            // errorCorrectionNewsId:'',//纠错的newsId
            // switchRequest:false//防止多次请求
        }
    },
    mounted() {
        let that = this;
		that.$parent.$refs.left.getPlanList(1);//进路由前获取方案列表
        let platformType = this.$route.query.platformType;
        let emotion = this.$route.query.emotion;
        if(platformType != '' && platformType != undefined){
            this.platformType = [platformType];
        }
        if(emotion != '' && emotion != undefined){
            this.emotion = emotion;
        }
        that.getMediaPlatform();
        that.getMouthTime();
        that.getUserMethod('wx');
        that.getUserMethod('email');
        that.getUserMethod('tel');
    },
    // beforeCreate (){
    //     
    // },
    beforeDestroy() {
        clearInterval(this.timeer);
    },
    created() {
		// 获取缓存方案数据
        this.planId = JSON.parse(sessionStorage.getItem('planStorage')).id;
    },
    methods: {
        //获取选中的方案
        getPlanvalue(e){
            this.mediaLevel = e;
            this.morenzhi = e;
            this.getNewsList(0);
            this.getMediaPlatform();
        },
        // 获取近一个月的时间
        getMouthTime(){
            this.endDate = this.$utils.getNowDate();//今天时间
            this.startDate = this.$utils.getBeforeDay(this.endDate,1,1);//前一天
        },
        // 相似文章去重选择
        selectRepeat (index) {
            this.collapse = index;
            this.getMediaPlatform();
            this.getNewsList(0);
        },
        // 设置
        openSetModal (){
            let that = this;
            that.$api.get('custom/multi-scheme/get-set',null,r =>{
                that.source = r.data.isFocus.toString();
                that.$refs.allInformationSet.showMaskFun();
            })
        },
        setSave (){
            let that = this;
            let data = {
                isFocus:that.source
            }
            that.$api.post('custom/multi-scheme/set',{data:data},r =>{
                that.$utils.alertText('设置成功！')
                that.$refs.allInformationSet.closeMask();
            })
        },
        //选择城市回调
        citySelect (name) {
            let that = this;
            that.watch = false;
            that.pubArea = name;
            that.getMediaPlatform();
        },
        // 获取媒体类型
        getMediaPlatform () {
            let that = this;
            // that.platformType = [];
            let data = {
                mediaLevel:that.mediaLevel,
                pubArea:that.pubArea,
                emotion:that.emotion,
                collapse:that.collapse,
                sid:that.sid,
                data:data
            };
            that.$api.post('custom/multi-scheme/media-platform',{data:data}, r => {
                that.$utils.returnCode(r,function(){
                    that.MediaPlatformList = r.data;
                    that.watch = false;
                    that.getNewsList(0);
                });
            })
        },
        // enter键搜索
        KeyUpEsc () {
            this.getNewsList(0);
        },
        // 获取新闻列表
        getNewsList (type) {
            let that = this;
            // if(that.$parent.showLoad == true){
            //     return;
            // }
            clearInterval(that.timer);//重置定时器
            that.noUpdateNum = 0;
            // that.switchRequest = true;
            if(type === 0){//非翻页
                that.page = 1;
            }
            let datas = {
                page:that.page,
                mediaLevel:that.mediaLevel,
                platformType:that.platformType,
                perpage:that.limit,
                pubArea:that.pubArea,
                emotion:that.emotion,
                keywords:that.keywords,
                collapse:that.collapse,
                sid:that.sid
            };
            that.uuids = [];
            $(".warp .checkbox-warp").removeClass('curr');
            $(".warp input:checkbox[name='selectAll']").prop("checked",false);
            that.$parent.loadModal(true,'正在获取数据...');
            that.$api.post('custom/multi-scheme/list', {data:datas}, r => {
                that.$parent.showLoad = false;
                that.$utils.returnCode(r,function(){
                    let data = r.data;
                    // that.keywords = '';
                    that.newsList = data.list;//新闻列表赋值 
                    that.totalCount = data.total;
                    let pageUuid = [];
                    let simHash = [];
                    let newsId = [];
                    for(let i of data.list){
                        pageUuid.push(i.newsId);
                    }
                    that.pageUuid = pageUuid;
                    if(data.list.length <= 0){//没有数据
                        that.nodata = true;
                        return;
                    }else{
                         that.nodata = false;
                    }
                    // 调用获取关键词和相似文章
                    that.getSimilarArticle(data.list);
                    // if(that.timeType != 1 && that.timeType != 4){//昨天和自定义不计未读书
                    //     that.getNotUpdated();
                    // }
                    // that.switchRequest = false;
                });
            })
        },
        // 获取最新未加载的消息
        getNotUpdated () {
            let that = this;
            let datas = {
                sid:that.sid===''?that.planId:that.sid,
                page:that.page,
                mediaLevel:that.mediaLevel,
                platformType:that.platformType,
                // startDate:that.startDate,
                perpage:that.limit,
                // endDate:that.endDate,
                pubArea:that.pubArea,
                city:that.city,
                emotion:that.emotion,
                match:that.match,
                sort:that.sort,
                searchType:that.searchSelectVal,
                keywords:that.keywords
            };
            that.timer = setInterval(() => {
                that.$api.post('monitor/info/find-new', {data:datas}, r => {
                    that.$utils.returnCode(r,function(){
                        that.noUpdateNum = r.data;
                    })
                })
            }, 300000);
        },
        // 更新当前数据
        updateCurrentData () {
            let that = this;
            // that.selectFixedTime(that.timeType);
            that.getMediaPlatform();
            that.noUpdateNum = 0;
        },
        // 获取关键词和相似文章
        getSimilarArticle (data) {
            let that = this;
            let oldData = data;
            let simHash = [];
            let newsIds = [];
            let postDate = [];
            let sids = [];
            for(let i of data){
                simHash.push(i.newsSimHash);
                newsIds.push(i.newsId);
                postDate.push(i.newsPostdate);
                sids.push(i.sid)
            }
			let datas = {
                mediaLevel:that.mediaLevel,
                startDate:that.startDate,
                endDate:that.endDate,
                pubArea:that.pubArea,
                emotion:that.emotion,
                platformType:that.platformType,
                keywords:that.keywords
			};
            that.$api.post('custom/multi-scheme/news-simnum', {simHash:simHash,newsId:newsIds,sid:sids,data:datas}, r => {
                that.$utils.returnCode(r,function(){
                    let datas = r.data;
                    for(let i of data){
                        for(let j in datas){
                            if(i.newsId === j){
                                i.simNum = datas[j].simNum;
                            }
                        }
                    }
                    if(that.newsList === oldData){
                        that.newsList = data;
                    }
                });
            })
            that.$api.post('custom/multi-scheme/news-keyword', {postDate:postDate,newsId:newsIds}, r => {
                that.$utils.returnCode(r,function(){
                    let datas = r.data;
                    for(let i of data){
                        for(let j in datas){
                            if(i.newsId === j){
                                i.keywords = datas[j].keywords;
                            }
                        }
                    }
                    if(that.newsList === oldData){
                        that.newsList = data;
                    }
                });
            })
        },
        // 下拉筛选
        dropDownSelect (type,name) {
            let that = this;
            that.watch = false;
            if(type == 0){//媒体类别
                if(name === '全部'){
                    that.mediaLevel = '';
                }else{
                    that.mediaLevel = name;
                }
            }else if(type === 1){//情感属性
                if(name === '全部'){
                    that.emotion = '';
                }else{
                    that.emotion = name;
                }
            }else if(type === 2){//匹配类型
                that.match = name;
            }else if(type === 3){//排序类型
                that.sort = name;
            }
            if(type === 0 || type === 1){
                that.getMediaPlatform();
            }
            that.getNewsList(0);
            that.getMediaPlatform();
        },
        // 全选状态
        checkAll (e) {
            let that = this;
            that.uuids = [];
            let checked = e.target.checked;
            if(checked == true){
                that.uuids = that.pageUuid;//全选的时候 获取所有的uuid
            }else{
                that.uuids = [];
            }
        },
        // 下载
        downLoad (type) {
            let that = this;
            that.downLoadType = type;
            let uuid = '';//全部下载为空
            if(type === 1){//选择下载
                uuid = that.uuids;
                if(uuid.length <= 0){
                    that.$utils.alertText('请选择需要下载的新闻');
                    return;
                }
            }else{
                if(that.newsList.length <= 0){
                    that.$utils.alertText('暂无可下载数据');
                    return;
                }
            }
            that.enterOption();
        },
        // 确定下载字段
        enterOption () {
            let that = this;
            let uuid = '';//全部下载为空
            let type = that.downLoadType;
            if(type === 1){//选择下载
                uuid = that.uuids;   
            }
            let data = {
                code:that.newsList[0].code,
                newsId:uuid,
                mediaLevel:that.mediaLevel,
                pubArea:that.pubArea,
                emotion:that.emotion,
                platformType:that.platformType,
                keywords:that.keywords,
                collapse:that.collapse
            };
            that.$parent.loadModal(true,'正在下载中，请耐心等待...');
            that.$api.post('custom/multi-scheme/download', {type:type,sid:that.sid===''?that.planId:that.sid,data:data}, r => {
                that.$parent.showLoad = false;
                that.$utils.returnCode(r,function(){
                    let url = r.data.url;
                    let html = '<a id="openDownload" href="'+url+'" download></a>';
                    $("body").append(html);
                    document.getElementById('openDownload').click();
                    $("#openDownload").remove();
                });
            })
        },
        // 下载字段全选
        optionCheckAll (e) {
            let that = this;
            that.selectOptionValue = [];
            let checked = e.target.checked;
            if(checked == true){
                let selectOption = that.selectOption;
                for(let i of selectOption){
                    that.selectOptionValue.push(i.type);
                }
            }else{
                that.selectOptionValue = [];
            }
            
        },
        //确认下载
        // enterDownload () {
            
        // },
        // 翻页
        getTableData () {
            let that = this;
            that.getNewsList(1);
        },
        //收藏
        collectFn (index) {
            let that = this;
            let newsList = that.newsList;
            let sc = newsList[index].collectStatus;//获取收藏状态
            let url = sc === 0 ? 'user/index/collect' : 'user/index/cancel-collect';
            let uUid = newsList[index].newsId;
            let data = {
                type:1,
                typeId:[uUid]
            };
            that.$parent.loadModal(true,'正在提交数据');
            that.$api.post(url, {data:data}, r => {
                that.$parent.showLoad = false;
                that.$utils.returnCode(r,function(){
                    sc = sc === 0 ? 1 : 0;
                    newsList[index].collectStatus = sc;
                    that.$utils.alertText('操作成功');
                });
                
            })
        },
        sendEarlyWarning (type,id){
            let isSupportArtificialWarningSet = this.$parent.isSupportArtificialWarningSet;//检测预警功能
            if(isSupportArtificialWarningSet != 1){
                this.$parent.alertTips('对不起，你暂无使用预警功能的权限！');
                return;
            }
            if(id === undefined){//批量预警
                if(this.uuids.length <= 0){
                    this.$utils.alertText('请选择需要预警的新闻');
                    return;
                }else{
                   this.newsId = this.uuids; 
                }
            }else{
                this.newsId.push(id);
                this.earlyWarningType = type;
            }
            if(type === 0){
                this.$refs.sendDialog.showMaskFun();
            }else{
               this.earlyWarning(); 
            }
        },
        // 预警
        earlyWarning () {
            let that = this;
            let contentArr = [];
            if(that.curWx!=''){
                contentArr.push(that.curWx);
            }
            if(that.curEmail!=''){
                contentArr.push(that.curEmail);
            }
            if(that.curTel!=''){
                contentArr.push(that.curTel);
            }
            let data = {
                newsId:that.newsId,
                contact:contentArr.toString(),
                sid:that.sid===''?that.planId:that.sid
            };
            let url = '';
            if(that.earlyWarningType === 0){//添加预警
                url = 'custom/multi-scheme/artificial-create';
            }else if(that.earlyWarningType === 1){//取消预警
                url = 'monitor/warning/artificial-delete';
            }
            that.$parent.loadModal(true,'正在提交数据');
            that.$api.post(url, {data:data}, r => {
                that.$parent.showLoad = false;
                that.$utils.returnCode(r,function(){
                    let newsList = that.newsList;
                    for(let i of that.newsId){
                        for(let j of newsList){
                            if(i === j.newsId){
                                if(that.earlyWarningType === 1){//取消
                                    j.warningStatus = 0;
                                }else{//预警
                                    j.warningStatus = 1;
                                }
                            }
                        }
                    }
                    that.$utils.alertText(that.yujinType);
                    that.$refs.sendDialog.closeMask();
                });
            })
        },
        //获取微信联系人
        getUserMethod(type){
            let that = this;
            that.$api.get('user/contact/list',{type:type}, r => {
                that.$utils.returnCode(r,function(){
                    if(type==='wx'){
                        that.wxList = r.data;
                    }else if(type==='email'){
                        that.emailList = r.data;
                    }else{
                        that.telList = r.data;
                    }
                })
            });
        },
        isHasUser(type){
            let that = this;
            if(that.wxList=='' && type ==1){
                that.$utils.alertText('请到“我的联系人”添加微信账号！',300);
            }else if(that.emailList=='' && type ==2){
                that.$utils.alertText('请到“我的联系人”添加邮箱地址！',300);
            }else if(that.telList=='' && type ==3){
                that.$utils.alertText('请到“我的联系人”添加手机号码！',300);
            }
        }
    },
    watch: {
        platformType(){
            let that = this;
            let len = that.platformType.length;
            if(that.platformType[0] === 'total' && len > 1){//选择非全部 
                that.platformType.splice(0,1);
            }else if(that.platformType[len-1] === 'total' && len > 1){
                that.platformType = ['total'];
            } 
            that.getNewsList(0);
        },
        emotion (newVal,oldVal) {
            let that = this;
		    let len = that.emotion.length;
		    if(that.emotion[0] === '全部' && len > 1){//选择非全部 
		        that.emotion.splice(0,1);
		    }else if(that.emotion[len-1] === '全部' && len > 1){
		        that.emotion = ['全部'];
            }
            if(this.queryFrist == true){
                return;
            }
		    that.getMediaPlatform();
        },
        checkedWx(){
            let that=this,nameArr=[],idArr=[];
            that.checkedWx.forEach((ele,index)=>{
                let tempEle = ele.split('-');
                nameArr.push(tempEle[0])
                idArr.push(tempEle[1])
            });
            let tempWx = nameArr.toString();
            that.curWx = idArr.toString();
            that.$set(that.reportForm,'wx',tempWx);
        },
        checkedEmail(){
            let that=this,nameArr=[],idArr=[];
            that.checkedEmail.forEach((ele,index)=>{
                let tempEle = ele.split('-');
                nameArr.push(tempEle[0])
                idArr.push(tempEle[1])
            });
            let tempWx = nameArr.toString();
            that.curEmail = idArr.toString();
            that.$set(that.reportForm,'email',tempWx);
        },
        checkedTel(){
            let that=this,nameArr=[],idArr=[];
            that.checkedTel.forEach((ele,index)=>{
                let tempEle = ele.split('-');
                nameArr.push(tempEle[0])
                idArr.push(tempEle[1])
            });
            let tempWx = nameArr.toString();
            that.curTel = idArr.toString();
            that.$set(that.reportForm,'tel',tempWx);
        },
        sid(){
            this.getMediaPlatform();
            this.getNewsList(0);
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/page/yuqingFenxi/allInformationSet.vue